module.exports = __webpack_public_path__ + "img/flashWarning.2b3dad77.png";